export const KNOWLEDGE_BASES = Object.freeze({
  WEB_PAGE: 'webPage',
  XML_FEED: 'xmlFeed',
  FILE: 'file'
})
